module.exports = __webpack_public_path__ + "static/img/sm_training.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm_training.jpg
// module id = EPRb
// module chunks = 0